import React from "react"
import { Paper, Tabs, Tab } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import { IJobDocument } from "../../../models"
import JobDetailPhases from "./JobDetailPhases"
import JobDetailLocation from "./JobDetailLocation"
import JobDetailSchedule from "./JobDetailSchedule"
import JobDetailTimecardsTab from "./JobDetailTimecardsTab"
import JobDetailPositions from "./JobDetailPositions"
import JobDetailWorkerPool from "./job-detail-worker-pool/JobDetailWorkerPool"
import JobDetailsExpenses from "./job-detail-expenses/JobDetailsExpenses"
import JobDetailsAssignedEmployees from "./job-details-assigned-employees/JobDetailsAssignedEmployees"
import JobDetailBudget from "./JobDetailBudget"
import JobDetailPhotos from "./job-detail-photos/JobDetailPhotos"
import HierarchySettings from "../../../components/hierarchy_settings/HierarchySettings"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import JobDetailsDevice from "./JobDetailsDevice"
import accountStore from "../../../stores/AccountStore"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"

interface IProps {
    readonly: boolean
    job: IJobDocument
    handleUpdateJob(job: IJobDocument): Promise<void>
    reloadJob(): void
    reloadJobWithPromise(): Promise<IJobDocument>
}
interface IState {
    activedTab: string
}

export default class JobDetailsData extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            activedTab: AccountStore.getTimecardEnabled() ? "timecard" : "location"
        }
    }
    render() {
        return (
            <Paper zDepth={1} style={{ textAlign: "left", margin: 20, marginTop: 20 }}>
                <Tabs
                    value={this.state.activedTab}
                    onChange={activedTab => this.setState({ activedTab })}
                >
                    {/* it's not implemented fully. let's hide for now.
                    {AccountStore.getNoteAttributesEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobAttributes) &&
                        <Tab data-intercom-target={"menu-Job-Attributes"} label={"Attributes"} value="attributes">
                            {this.state.activedTab === "attributes" && this.props.job &&
                                <div className="detail-tab">
                                    <NotesObjectAttributeList
                                        objectId={this.props.job.Id}
                                    />
                                </div>
                            }
                        </Tab>
                    } */}
                    {/* {AccountStore.getCRMEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobWorkerPool) &&
                        <Tab
                            label={[<div key="top">{strings.Worker_Pool.split(" ")[0]}</div>, <div key="bottom">{strings.Worker_Pool.split(" ")[1]}</div>]}
                            value="workerpool"
                        >
                            {this.state.activedTab === "workerpool" &&
                                <JobDetailWorkerPool
                                    readonly={this.props.readonly}
                                    job={this.props.job}
                                    reloadJob={this.props.reloadJob}
                                    reloadJobWithPromise={this.props.reloadJobWithPromise}
                                />
                            }
                        </Tab>
                    } */}
                    {AccountStore.getTimecardEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobTimecard) &&
                        <Tab
                            data-intercom-target={"menu-Jobs-JobDetails-TimecardTab"}
                            title={strings.Timecards}
                            label={strings.Timecards.includes(" ") ?
                                (() => {
                                    const subStrings = strings.Timecards.split(" ")
                                    const topLength = Math.floor(subStrings.length / 2)
                                    const topStrings = subStrings.slice(0, topLength)
                                    const bottomStrings = subStrings.slice(topLength, subStrings.length)
                                    return ([
                                        <div key="top" className="TextOverflow" style={{ width: "100%" }}>{topStrings.join(" ")}</div>,
                                        <div key="bottom" className="TextOverflow" style={{ width: "100%" }}>{bottomStrings.join(" ")}</div>
                                    ])
                                })() :
                                strings.Timecards
                            }
                            value="timecard"
                        >
                            {this.state.activedTab === "timecard" &&
                                <JobDetailTimecardsTab
                                    job={this.props.job}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getScheduleEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobSchedule) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-ScheduleTab"} label={strings.Schedule} value="schedule">
                            {this.state.activedTab === "schedule" &&
                                <JobDetailSchedule
                                    readonly={this.props.readonly}
                                    job={this.props.job}
                                />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobLocation) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-LocationTab"} label={strings.Location} value="location">
                            {this.state.activedTab === "location" &&
                                <JobDetailLocation
                                    job={this.props.job}
                                    handleUpdateJob={this.props.handleUpdateJob}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getPayClassEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobBudget) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-AssignedEmployeesTab"} label={strings.Budget} value="budget">
                            {this.state.activedTab === "budget" &&
                                <JobDetailBudget
                                    readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.EditJobBudget)}
                                    job={this.props.job}
                                    reloadJob={this.props.reloadJob}
                                    loading={false}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getExpensesEnabled() && AccountStore.getCRMEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobExpenses) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-ExpensesTab"} label={strings.Expenses} value="expenses">
                            {this.state.activedTab === "expenses" &&
                                <JobDetailsExpenses
                                    readonly={this.props.readonly}
                                    job={this.props.job}
                                    reloadJob={this.props.reloadJob}
                                />
                            }
                        </Tab>
                    }
                    {AccountStore.getPhasesEnabled() &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewPhases) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-PhasesTab"} label={checkPhaseFieldAvailable("plural") ? accountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.PluralPhaseLabel : strings.Phases} value="phases">
                            {this.state.activedTab === "phases" &&
                                <JobDetailPhases
                                    readonly={this.props.readonly}
                                    job={this.props.job}
                                    handleUpdateJob={this.props.handleUpdateJob}
                                />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewAssignedEmployee) &&
                        <Tab
                            data-intercom-target={"menu-Jobs-JobDetails-AssignedEmployeesTab"}
                            label={[<div key="top">{strings.Assigned_Employee.split(" ")[0]}</div>, <div key="bottom">{strings.Assigned_Employee.split(" ")[1]}</div>]}
                            value="assigned-employees"
                        >
                            {this.state.activedTab === "assigned-employees" &&
                                <JobDetailsAssignedEmployees job={this.props.job} readonly={this.props.readonly} reloadJob={this.props.reloadJob} />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewJobDevices) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-DeviceTab"} label={strings.Device} value="device">
                            {this.state.activedTab === "device" &&
                                <JobDetailsDevice
                                    job={this.props.job}
                                    addDevicePermission={permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.AddJobDevices)}
                                    editDevicePermission={permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.EditJobDevices)}
                                    deleteDevicePermission={permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.DeleteJobDevices)}
                                />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobPositions) &&
                        <Tab data-intercom-target={"menu-Jobs-JobDetails-PositionTab"} label={checkPositionFieldAvailable('plural') ? accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel : strings.Positions} value="positions">
                            {this.state.activedTab === "positions" &&
                                <JobDetailPositions
                                    readonly={this.props.readonly}
                                    job={this.props.job}
                                    reloadJob={this.props.reloadJob}
                                />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobPhotos) &&
                        <Tab
                            data-intercom-target={"menu-Jobs-JobDetails-Photos"}
                            label={strings.Photos}
                            value="photos"
                        >
                            {this.state.activedTab === "photos" &&
                                <JobDetailPhotos
                                    readonly={this.props.readonly}
                                    jobId={this.props.job.Id}
                                />
                            }
                        </Tab>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.JobTabs.ViewJobSettings) &&
                        <Tab
                            data-intercom-target={"menu-Jobs-JobDetails-HierarchySettingsTab"}
                            label={strings.Settings}
                            value="settings"
                        >
                            {this.state.activedTab === "settings" &&
                                <Paper zDepth={1}>
                                    <div style={{ padding: 20 }}>
                                        <HierarchySettings
                                            readonly={this.props.readonly}
                                            hierarchyJobItem={this.props.job}
                                            handleUpdateJob={this.props.handleUpdateJob}
                                        />
                                    </div>
                                </Paper>
                            }
                        </Tab>
                    }
                </Tabs>
            </Paper >
        )
    }
}